<template>
  <transition name="fade" mode="out-in" appear>
    <VSpinner v-if="isLoading" class="offset-top-2" />
    <article v-else class="offset-top-2">
      <VNotification v-if="hasNoServices" type="ERROR" heading="payment.no_services_available" role="note" />
      <VForm v-else :form="form" @submit="onNextStep">
        <VNotification type="WARNING" heading="payment.hint_headline" role="note">
          <VCheckbox v-model="isChargingNote" v-focus name="checkbox" required inline>
            {{ $t('payment.payment_generation_cost_hint') }}
          </VCheckbox>
        </VNotification>

        <VServiceDisplay v-model="selectedService" :services="availableServices" />

        <VButton type="submit" :disabled="isButtonDisabled" label="payment.progress_button_next_step" class="btn-default btn-brand pull-right offset-top-2" />
      </VForm>
    </article>
  </transition>
</template>

<script>
import { PAYMENT_GENERATION_DATA } from '@/router/route-types';
import VSpinner from '@/components/Spinner';
import VCheckbox from '@/components/Form/Checkbox';
import VNotification from '@/components/Notification';
import VButton from '@/components/Button';
import VForm from '@/components/Form/Form';
import VServiceDisplay from '@/components/PaymentGeneration/ServiceDisplay';
import focus from '@/directives/focus';

import { initFields } from '@/utils/form';
import { mapActions, mapState } from 'vuex';
import Proxy from '@/proxies/PaymentGenerationProxy';

export default {
  name: 'ProductSelection',

  components: {
    VSpinner,
    VCheckbox,
    VNotification,
    VButton,
    VForm,
    VServiceDisplay,
  },

  directives: { focus },

  data() {
    return {
      isLoading: true,
      form: null,
      proxy: new Proxy(),
      availableServices: [],
      selectedService: '',
    };
  },

  computed: {
    ...mapState('payment', ['chargingNote', 'serviceId']),

    isChargingNote: {
      get() {
        return this.chargingNote;
      },
      set(value) {
        this.setChargingNote(value);
      },
    },

    hasNoServices() {
      return this.availableServices.length === 0;
    },

    isButtonDisabled() {
      return !this.isChargingNote || this.selectedService === '';
    },
  },

  async created() {
    // isLoading is initially true, see data object
    this.form = initFields({ name: 'checkbox' });
    this.availableServices = await this.proxy.overview();
    this.selectedService = this.availableServices.length === 1 ? this.availableServices[0] : this.serviceId;
    this.isLoading = false;
  },

  methods: {
    ...mapActions('payment', ['setChargingNote', 'fetchServiceData']),

    async onNextStep() {
      if (this.isChargingNote) {
        this.isLoading = true;
        await this.fetchServiceData(this.selectedService);
        this.isLoading = false;
        await this.$router.push({
          name: PAYMENT_GENERATION_DATA,
        });
      }
    },
  },
};
</script>
